import { Button } from "../components/Button";
import { ScaleInput } from "../components/ScaleInput";
import { useFlow } from "../flow/FlowContext";
import { REQUIRED_SCALES, VALUE_SCALES } from "../flow/steps";
import { useT } from "../i18n";

export function ValueScalesScreen() {
  const { answers, setScale, next, canContinue, continueHint } = useFlow();
  const t = useT();

  return (
    <div className="prompt prompt--sheet screen-enter">
      <header className="screen-head">
        <div className="screen-head__eyebrow">{t("scales.eyebrow")}</div>
        <h1 className="screen-head__title">{t("scales.title")}</h1>
        <p className="screen-head__text">{t("scales.text")}</p>
      </header>
      <div className="stack">
        {VALUE_SCALES.map((s) => (
          <ScaleInput
            key={s.key}
            id={`scale-${s.key}`}
            label={t(`scales.${s.key}.label`)}
            hint={t(`scales.${s.key}.hint`)}
            value={answers.scales[s.key] ?? null}
            onChange={(n) => setScale(s.key, n)}
            optional={!REQUIRED_SCALES.includes(s.key)}
          />
        ))}
        {continueHint ? <p className="shell__hint">{continueHint}</p> : null}
        <div className="prompt__next">
          <Button onClick={next} disabled={!canContinue}>
            {t("common.next")}
          </Button>
        </div>
      </div>
    </div>
  );
}
